import { render, staticRenderFns } from "./LabelCount.vue?vue&type=template&id=73b9cc9a&scoped=true&"
import script from "./LabelCount.vue?vue&type=script&lang=js&"
export * from "./LabelCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9cc9a",
  null
  
)

export default component.exports